(function () {
    const getDescriptionButton = () =>
        document.querySelector('.accordian_button.description') ||
        document.querySelector('.accordian_button.descripcion');

    const ensureDescriptionAnchor = (descriptionButton) => {
        const accordion = descriptionButton.closest('.accordian_main');
        if (accordion && !accordion.id) {
            accordion.id = 'product-description';
        }
        return accordion?.id ? `#${accordion.id}` : '#product-description';
    };

    const openDescriptionAccordion = (descriptionButton) => {
        const accordion = descriptionButton.closest('.accordian_main');
        const content = accordion?.querySelector(
            '.accordion-content.description, .accordion-content.descripcion'
        );
        if (content && window.getComputedStyle(content).display === 'none') {
            descriptionButton.click();
        }
        descriptionButton.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const bindHighlights = () => {
        const descriptionButton = getDescriptionButton();
        if (!descriptionButton) return false;

        const href = ensureDescriptionAnchor(descriptionButton);
        let bound = false;

        document.querySelectorAll('.smart-bot-product-highlights__item').forEach((item) => {
            if (item.closest('a[data-smart-bot-description-link]')) return;

            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('data-smart-bot-description-link', 'true');
            link.style.cssText = 'text-decoration:none;color:inherit;';

            item.replaceWith(link);
            link.appendChild(item);

            link.addEventListener('click', (e) => {
                e.preventDefault();
                openDescriptionAccordion(descriptionButton);
            });

            bound = true;
        });

        return bound;
    };

    // Try immediately (script is deferred, DOM is ready)
    if (bindHighlights()) return;

    // SmartBot injects highlights async — observe until they appear, then disconnect
    let debounceTimer;
    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            if (bindHighlights()) {
                observer.disconnect();
            }
        }, 100);
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();
